import React from 'react';
import { SectionHeading } from '../../../../ui';

export function LandingWhyUs() {
  return (
    <>
      <section className="section section--benefits content-width" id="benefits" data-figma-node="125:48267" aria-labelledby="benefits-title">
        <SectionHeading
          title={<>Чем LOVO лучше поиска<br />по соцсетям</>}
          titleId="benefits-title"
          description="Главное — спокойствие за животное. Шесть вещей, которых нет, когда ищешь перевозчика по чатам и группам."
        />
        <div className="benefits-grid" id="benefits-grid"></div>
      </section>

      <section className="soon content-width" data-figma-node="125:49602" aria-labelledby="soon-title">
        <div className="soon__label"><span id="soon-title">Скоро<br />на платформе</span></div>
        <div className="soon__arrow" aria-hidden="true"><img src="/assets/figma/soon-arrow-right.svg" alt="" /></div>
        <div className="soon__item">Поиск и бронь услуг<br />передержки</div>
        <div className="soon__item soon__item--wide">GPS-отслеживание перевозки<br />в реальном времени</div>
      </section>

      <section className="newsletter content-width" data-figma-node="124:40550" aria-labelledby="newsletter-title">
        <img className="newsletter__mark" src="/assets/landing/newsletter-mark.svg" alt="" aria-hidden="true" />
        <article className="newsletter-card">
          <div className="newsletter-card__media">
            <img src="/assets/landing/newsletter-pet.webp" alt="Собака" />
          </div>
          <div className="newsletter-card__content">
            <h2>Скоро на платформе</h2>
            <div className="newsletter-card__features">
              <p><img src="/assets/figma/newsletter-point.svg" alt="" />Поиск и бронь услуг передержки</p>
              <p><img src="/assets/figma/newsletter-point.svg" alt="" />GPS-отслеживание перевозки в&nbsp;реальном&nbsp;времени</p>
            </div>
          </div>
        </article>
        <div className="newsletter__form-column">
          <SectionHeading
            title="Подпишитесь на новости"
            titleId="newsletter-title"
            description="Мы развиваемся. Обещаем не спамить и присылать только важные новости и обновления!"
          />
          <form className="newsletter-form">
            <div className="newsletter-form__fields">
              <label><i className="newsletter-form__name-icon" aria-hidden="true" /><span><b>Имя</b><input name="name" placeholder="Иван" autoComplete="name" /></span></label>
              <label><img src="/assets/figma/newsletter-email.svg" alt="" /><span><b>Электронная почта</b><input name="email" type="email" placeholder="example@gmail.com" autoComplete="email" required /></span></label>
            </div>
            <button className="button" type="submit">Подписаться на рассылку <img className="button__icon" src="/assets/figma/button-arrow-up-right-white.svg" alt="" /></button>
            <span className="newsletter-form__status" role="status" aria-live="polite"></span>
          </form>
        </div>
      </section>
    </>
  );
}
